import R from 'ramda'
import {
  numCol,
  strCol,
  dateCol,
  dateTimeCol,
  intCol,
} from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
// import { modifiedDateCol, modifierGetter } from 'core/HeaderColTypeProps'
// import { yesNoMap } from 'core'

export const PlantHeaders = [
  strCol({
    ident: 'entityId',
    display: 'Entity ID',
    isKey: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({ ident: 'plantId', display: 'Plant ID', width: 200, isKey: true }),
  strCol({
    ident: 'plantName',
    display: 'Plant Name',
    isRequired: true,
    width: 200,
    ellipsis: true,
  }),
  // strCol({
  //   ident: 'region',
  //   display: 'Region',
  //   isRequired: true,
  //   width: 250,
  //   ellipsis: true,
  // }),
  strCol({
    ident: 'eiaPlantCode',
    display: 'EIA Plant Code',
    isRequired: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({
    ident: 'isoResourceId',
    display: 'ISO Resource ID',
    width: 200,
    isFiltered: true,
  }),
  strCol({
    ident: 'country',
    display: 'Country',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  strCol({
    ident: 'nearestCity',
    display: 'Nearest City',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  // strCol({
  //   ident: 'plantOwnershipStatus',
  //   display: 'Plant Ownership Status',
  //   isFiltered: true,
  //   width: 150,
  //   isRequired: true,
  // }),
  // dateCol({
  //   ident: 'effectiveDate',
  //   display: 'Effective Date (mm/dd/yyyy)',
  //   isFiltered: true,
  //   isRequired: true,
  // }),
  // strCol({
  //   ident: 'country',
  //   display: 'Country',
  //   isFiltered: true,
  //   width: 200,
  //   ellipsis: true,
  //   isRequired: true,
  // }),
  strCol({
    ident: 'stateProvince',
    display: 'State/Province',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  // strCol({
  //   ident: 'nearestCity',
  //   display: 'Nearest City',
  //   isFiltered: true,
  //   width: 200,
  //   ellipsis: true,
  //   isRequired: true,
  // }),

  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  // strCol({
  //   ident: 'daylightSaving',
  //   display: 'Daylight Savings',
  //   isFiltered: true,
  //   ...toSelectionColProps(yesNoMap),
  //   width: 100,
  //   isRequired: true,
  // }),
  // numCol({
  //   ident: 'solarRegime',
  //   display: 'Solar Regime',
  //   isFiltered: true,
  //   width: 450,
  //   ellipsis: true,
  //   isRequired: true,
  // }),
  numCol({
    ident: 'latitude',
    display: 'Latitude',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'longitude',
    display: 'Longitude',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'elevationM',
    display: 'Elevation (m)',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'solarRegime',
    display: 'Solar Regime Environment',
    isFiltered: true,
    width: 300,
    ellipsis: true,
    isRequired: true,
  }),

  numCol({
    ident: 'globalHIrradiance',
    display: 'Global Horizontal Irradiance',
    width: 300,
    ellipsis: true,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'interAnnualVarIrr',
    display: 'Inter-Annual Variance of Irradiance',
    isFiltered: true,
    width: 300,
    isRequired: true,
  }),
  numCol({
    ident: 'plantCapPoi',
    display: 'Plant Capacity at POI',
    isFiltered: true,
    isRequired: true,
    width: 300,
  }),
  strCol({
    ident: 'onSiteStorage',
    display: 'On-Site Connected Energy Storage',
    isFiltered: true,
    isRequired: true,
    width: 300,
  }),
  // strCol({
  //   ident: 'transferToEntityId',
  //   display: 'Transfer to Entity ID',
  //   isFiltered: true,
  // }),
  strCol({
    ident: 'plantOwnershipStatus',
    display: 'Plant Ownership Status',
    isFiltered: true,
    width: 300,
    isRequired: true,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isFiltered: true,
    isRequired: true,
    width: 300,
  }),

  // modifierCol,
  // modifiedDateCol,
]

export const InverterGroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'Entity ID',
    isKey: true,
    width: 200,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({
    ident: 'inverterGroupId',
    display: 'Inverter Group ID',
    width: 200,
    isKey: true,
  }),
  strCol({
    ident: 'inverterGroupName',
    display: 'Inverter Group Name',
    isRequired: true,
    width: 200,
  }),
  dateCol({
    ident: 'commissionDate',
    display: 'Commercial Date',
    width: 200,
    isFiltered: true,
  }),
  // dateCol({
  //   ident: 'effectiveDate',
  //   display: 'Effective Date (mm/dd/yyyy)',
  //   // isKey: true,
  //   isRequired: true,
  // }),
  intCol({
    ident: 'numInverters',
    display: 'Number of Inverters for Inverter Group',
    isFiltered: true,
    width: 350,
    isRequired: true,
  }),
  // numCol({
  //   ident: 'groupInstalledCap',
  //   display: 'Group Installed Capacity (MW)',
  //   isFiltered: true,
  //   width: 200,
  //   isRequired: true,
  // }),
  // intCol({
  //   ident: 'numInverters',
  //   display: 'Number of Inverters',
  //   isFiltered: true,
  //   width: 200,
  //   isRequired: true,
  // }),
  numCol({
    ident: 'singleInvSystemCap',
    display: 'Single Inverter System Capacity',
    isFiltered: true,
    width: 300,
    isRequired: true,
  }),
  numCol({
    ident: 'singleInvNameplateCap',
    display: 'Single Inverter AC Nameplate',
    isFiltered: true,
    width: 250,
  }),
  strCol({
    ident: 'invManufacturer',
    display: 'Inverter Manufacturer',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'invModel',
    display: 'Inverter Model',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'SCADA Manufacturer',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'scadaModel',
    display: 'SCADA Model',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'dcInputType',
    display: 'DC Input Type',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'dcAcFieldCapRatio',
    display: 'Aggregate DC to AC Field Capacity Ratio',
    isFiltered: true,
    width: 350,
  }),
  strCol({
    ident: 'panelTrackingType',
    display: 'Panel Tracking Type',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'panelTiltAngle',
    display: 'Panel Tilt Angle',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'minIrradiance',
    display: 'Minimum Irradiance',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'stowingWindSpeed',
    display: 'Stowing Wind Speed',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'minOpTemperature',
    display: 'Minimum Operating Temperature',
    isFiltered: true,
    width: 300,
  }),
  intCol({
    ident: 'maxOpTemperature',
    display: 'Maximum Operating Temperature',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'temperatureCoefficient',
    display: 'Temperature Coefficient',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'nameplateEfficiency',
    display: 'Nameplate Panel Efficiency',
    isFiltered: true,
    width: 250,
  }),

  // strCol({
  //   ident: 'transferToEntityId',
  //   display: 'Transfer to Entity ID',
  //   isFiltered: true,
  // }),
  strCol({
    ident: 'invOwnershipStatus',
    display: 'Inverter Ownership Status',
    // isKey: true,
    width: 250,
    isRequired: true,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    // isKey: true,
    isRequired: true,
    width: 200,
  }),
]

const headerWithFormatter = headers => {
  return headers.map(header =>
    header.ident === 'extension'
      ? {
          ...header,
          dataFormatter: ({ rowData }) => rowData.extension?.causecode1 || '',
        }
      : header
  )
}

export const NercEventIoHeaders = (width, contribConditionList = []) => {
  const conMap = R.compose(
    R.fromPairs,
    R.map(d => [d.contOpCode, d.contOpCode + ' - ' + d.contOpCondition])
  )(contribConditionList)
  const headers = [
    // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
    // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
    // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),
    strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
    strCol({
      ident: 'eventId',
      display: 'Event ID',
      isKey: true,
      sortOrder: 'asc',
    }),
    strCol({ ident: 'eventstartTimeZone', display: 'Time Zone', isKey: true }),
    dateTimeCol({
      ident: 'eventstart',
      display: 'Start Date/Time',
      isKey: true,
      sortOrder: 'asc',
      width: 200,

      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
    }),
    dateTimeCol({
      ident: 'eventend',
      display: 'End Date/Time',
      isFiltered: true,
      sortOrder: 'asc',
      width: 200,

      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
    }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      width: 200,
      isFiltered: true,
      sortOrder: 'asc',
    }),
    intCol({
      ident: 'causecode',
      display: 'Primary Cause Code',
      width: 200,
      isFiltered: true,
      sortOrder: 'asc',
    }),
    intCol({
      ident: 'extension',
      display: 'Additional Cause Code',
      width: 200,
      isFiltered: true,
    }),
    strCol({
      ident: 'contributingCondition',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      ...toSelectionColProps(conMap),
      alignment: 'left',
      width: 300,
      ellipsis: true,
    }),
    strCol({
      ident: 'description',
      display: 'Description',
      width: 200,
      isFiltered: true,
    }),
    numCol({
      ident: 'potentialLoss',
      display: 'MWH Loss',
      isFiltered: true,
      width: 150,
    }),
    // numCol({
    //   ident: 'potentialLoss',
    //   display: 'PotentialLoss',
    //   isFiltered: true,
    // }),

    // modifierCol,
    // modifiedDateCol,
  ]
  // const lastHeaders = [
  //   numCol({
  //     ident: 'potentialLoss',
  //     display: 'Potential Generation Loss (MWh)',
  //     isFiltered: true,
  //     width: 200,
  //   }),
  // //   modifierCol,
  // //   modifiedDateCol,
  // ]

  // const getWidth = hd => hd.map(h => h.width || 100).reduce((a, b) => a + b)

  // let descwidth = width - getWidth(headers) - getWidth(lastHeaders) - 20
  // if (descwidth < 0) descwidth = 150
  // const desc = strCol({
  //   ident: 'description',
  //   display: 'Event Description',
  //   isFiltered: true,
  //   width: descwidth,
  //   ellipsis: true,
  //   alignment: 'left',
  // })
  // return [...headers, desc, ...lastHeaders]
  return headerWithFormatter(headers)
}

export const PerformanceIoHeaders = [
  // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isFiltered: true }),
  strCol({ ident: 'plantId', display: 'Plant ID', isFiltered: true }),
  strCol({
    ident: 'inverterGroupId',
    display: 'Inverter Group ID',
    width: 200,
    isFiltered: true,
  }),
  // strCol({
  //   ident: 'inverterGroupName',
  //   display: 'Inverter Group Name',
  //   isFiltered: true,
  //   width: 150,
  //   sortOrder: 'asc',
  //   sortIndexGetter: ({ rowData }) =>
  //     rowData.inverterGroupName === 'TOTAL'
  //       ? 'ZZZZZZZ'
  //       : rowData.inverterGroupName,
  // }),
  numCol({
    ident: 'month',
    display: 'Reporting Period (Month)',
    width: 250,
    isFiltered: true,
  }),
  numCol({
    ident: 'year',
    display: 'Reporting Year',
    width: 200,
    isFiltered: true,
  }),
  strCol({
    ident: 'invGroupAvailability',
    display: 'Inverter Group Availability Status',
    width: 300,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'grossactgen',
    display: 'Gross Actual Generation (GAG)',
    width: 300,
    isFiltered: true,
  }),
  numCol({
    ident: 'netactgen',
    display: 'Net Actual Generation (NAG)',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'netmaxcap',
    display: 'Net Maximum Capacity (NMC)',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'monthlyPoa',
    display: 'Monthly Plane of Array',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'performanceRatio',
    display: 'Performance Ratio',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'expectedGen',
    display: 'Expected Generation',
    width: 200,
    isFiltered: true,
  }),
  numCol({
    ident: 'activeSolarIh',
    display: 'Active Solar Inverter Hours',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'activeIh',
    display: 'Active Inverter Hours',
    width: 250,
    isFiltered: true,
  }),
  numCol({
    ident: 'inactiveReserveIh',
    display: 'Inactive Reserve Inverter Hours',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'mothballedIh',
    display: 'Mothballed Inverter Hours',
    width: 300,
    isFiltered: true,
  }),
  numCol({
    ident: 'retiredIh',
    display: 'Retired Unit Inverter Hours',
    width: 300,
    isFiltered: true,
  }),
  numCol({
    ident: 'serviceIhDay',
    display: 'Service Inverter Hours Day',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'rsIh',
    display: 'Reserve Shutdown Inverter Hours',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'foIhDay',
    display: 'Forced Outage Inverter Hours Day',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'moIhDay',
    display: 'Maintenance Inverter Hours Day',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'poIhDay',
    display: 'Planned Inverter Hours Day',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'resourceUnaIhDay',
    display: 'Resource Unavailable Inverter Hours Day',
    width: 300,
    isFiltered: true,
  }),
  numCol({
    ident: 'serviceIhNight',
    display: 'Service Inverter Hours Night',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'foIhNight',
    display: 'Forced Outage Inverter Hours Night',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'moIhNight',
    display: 'Maintenance Inverter Hours Night ',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'poIhNight',
    display: 'Planned Inverter Hours Night',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'resourceUnaIhNight',
    display: 'Resource Unavailable Inverter Hours Night',
    isFiltered: true,
    width: 300,
  }),
  // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  // strCol({ ident: 'action', display: 'Action', isFiltered: true }),

  // modifierCol,
  // modifiedDateCol,
]

export const StoragePerformanceIoHeaders = [
  // strCol({
  //   ident: 'entityId',
  //   display: 'NCR ID/NERC ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  //   width: 200,
  // }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'storageGroupId',
    display: 'Storage Group Id',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  intCol({
    ident: 'month',
    display: 'Reporting Month',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  intCol({
    ident: 'year',
    display: 'Reporting Year',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'storageGroupAvailability',
    display: 'Storage Group Availability Status',
    isFiltered: true,
    sortOrder: 'asc',
    width: 300,
  }),
  numCol({
    ident: 'chargeMwh',
    display: 'Charge Generation',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'dischargeMwh',
    display: 'Discharge Generation',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'chargeHrs',
    display: 'Charging Hours',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeHrs',
    display: 'Discharging Hours',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'foHrs',
    display: 'Forced Outage Hours',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'moHrs',
    display: 'Maintenance Outage Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'poHrs',
    display: 'Planned Outage Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
]
